"use client";

import type { ReactNode } from "react";

const URL_RE = /(?:\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))|(?:(https?:\/\/[^\s<]+[^\s<.,;:!?)"\]]))/g;

function parseTextWithLinks(text: string): ReactNode[] {
  const parts: ReactNode[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(URL_RE)) {
    const fullMatch = match[0];
    const matchStart = match.index!;

    if (matchStart > lastIndex) {
      parts.push(text.slice(lastIndex, matchStart));
    }

    const mdLabel = match[1];
    const mdUrl = match[2];
    const plainUrl = match[3];

    const href = mdUrl ?? plainUrl;
    const label = mdLabel ?? plainUrl;

    parts.push(
      <a
        key={matchStart}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary underline underline-offset-2 hover:text-primary/80"
      >
        {label}
      </a>
    );

    lastIndex = matchStart + fullMatch.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
}

export function LinkifiedText({ text }: { text: string }) {
  const lines = text.split("\n");

  return (
    <>
      {lines.map((line, i) => (
        <span key={i}>
          {parseTextWithLinks(line)}
          {i < lines.length - 1 && "\n"}
        </span>
      ))}
    </>
  );
}
